import classNames from "classnames";
import React, { useState } from "react";
import { localize } from "src/l10n";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { UnstyledButton } from "../../Buttons";
import { IImageBlockImage } from "../imageBlockContent";
import "./ImageBlockThumbnails.scss";

const dragDataType = "application/x-spintr-image-block-index";

interface IProps {
    images: IImageBlockImage[];
    onChange: (images: IImageBlockImage[]) => void;
}

const ImageBlockThumbnails = (props: IProps) => {
    const [dragIndex, setDragIndex] = useState<number | undefined>(undefined);
    const [overIndex, setOverIndex] = useState<number | undefined>(undefined);

    const resetDrag = () => {
        setDragIndex(undefined);
        setOverIndex(undefined);
    };

    const moveImage = (fromIndex: number, toIndex: number) => {
        if (fromIndex === toIndex) {
            return;
        }

        const images = [...props.images];
        const [movedImage] = images.splice(fromIndex, 1);
        images.splice(toIndex, 0, movedImage);

        props.onChange(images);
    };

    return (
        <div className="ImageBlockThumbnails">
            {props.images.map((image: IImageBlockImage, index: number) => (
                <div
                    key={index + "-" + image.content}
                    className={classNames("ImageBlockThumbnails-item", {
                        "is-dragging": dragIndex === index,
                        "is-drop-target": overIndex === index && dragIndex !== undefined && dragIndex !== index,
                    })}
                    draggable
                    onDragStart={(event: React.DragEvent<HTMLDivElement>) => {
                        event.dataTransfer.effectAllowed = "move";
                        event.dataTransfer.setData(dragDataType, index.toString());
                        setDragIndex(index);
                    }}
                    onDragOver={(event: React.DragEvent<HTMLDivElement>) => {
                        if (dragIndex === undefined) {
                            return;
                        }

                        event.preventDefault();
                        event.dataTransfer.dropEffect = "move";
                        setOverIndex(index);
                    }}
                    onDrop={(event: React.DragEvent<HTMLDivElement>) => {
                        event.preventDefault();

                        if (dragIndex !== undefined) {
                            moveImage(dragIndex, index);
                        }

                        resetDrag();
                    }}
                    onDragEnd={resetDrag}
                >
                    <img src={image.content} alt="" draggable={false} />
                    <UnstyledButton
                        className="ImageBlockThumbnails-remove"
                        title={localize("TaBortBild")}
                        onClick={() => {
                            props.onChange(props.images.filter((_, imageIndex: number) => imageIndex !== index));
                        }}
                    >
                        <Visage2Icon icon="close-circle" size="small" />
                    </UnstyledButton>
                </div>
            ))}
        </div>
    );
};

export default ImageBlockThumbnails;
